// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAusdg } from "../../../icons/mono/build/icon-ausdg.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AusdgIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAusdg.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AusdgIcon.displayName = 'AusdgIcon';
}

export default AusdgIcon;